import { rest, setupWorker, SetupWorkerApi } from 'msw';
import { handlers } from './handlers';

let setupWorkerApi: SetupWorkerApi = {} as SetupWorkerApi;

if (process.env.REACT_APP_USE_MOCK_API === 'true') {
  setupWorkerApi = setupWorker(...handlers);

  // Store msw on window to access it in e2e-test
  window.msw = {
    worker: setupWorkerApi,
    rest,
  };
}

export const worker = setupWorkerApi;
